
export const Language = 'en-US';

export const MomentOptions = {
	apiFormat: 'YYYY-MM-DD',
	displayFormat: 'ddd, MMM D',
	birthFormat: 'MMMM D, YYYY',
};

export const DateOptions = {
	weekday: 'long',
	year: 'numeric',
	month: 'long',
	day: 'numeric',
};

export const TimeOptions = {
	timeZone: 'America/New_York',
	hour: '2-digit',
	minute: '2-digit',
	timeZoneName: 'short',
};
